import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCountriesApi } from "src/network/api";

const CountrySelector = ({ currentCountry, onSelectCountryCallback }) => {
  const [countries, setCountries] = useState([]);

  const fetchCountries = async () => {
    try {
      const response = await getCountriesApi();
      setCountries(response.data.data);
    } catch (e) {
      console.log("Fetch Error:", e);
      toast.error(e.response?.data?.message ?? e.message);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  return (
    <div>
      <select
        onChange={(e) => onSelectCountryCallback(e.target.value)}
        value={currentCountry}
        id="country-select"
      >
        <option value="">Select Country</option>
        {countries.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CountrySelector;
